import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * The id of a form field's hint text, for the input's `aria-describedby`.
 * Pairs with `FormField` — see the placeholder rule in CLAUDE.md.
 */
export const hintId = (fieldId: string) => `${fieldId}-hint`
